import { Component, OnInit, Input } from '@angular/core';
import { TranslateService } from './../../../api/translate.service';
import { TransactionValidationService } from './../../../utils/validation/transaction-validation.service';
import { UserProfileService } from '../../../api/user-profile.service';
import { DataObject } from '../../../interfaces/data-objects';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'iv-single-page-validation',
  templateUrl: './single-page-validation.component.html',
  styleUrls: ['./single-page-validation.component.scss']
})
export class SinglePageValidationComponent implements OnInit {

  @Input() submitResult: DataObject;
  @Input() pageSlug = '';
  @Input() pageName = '';
  @Input() pageLink = '';

  queryParams: DataObject = {};

  constructor(
    private activatedRoute: ActivatedRoute,
    private transactionValidationService: TransactionValidationService,
    private userProfileService: UserProfileService,
    private translateService: TranslateService
  ) { }

  ngOnInit() {
    this.getUserCountry();
    this.queryParams = this.setQueryParams(this.pageSlug, this.queryParams);
  }

  getUserCountry() {
    return this.userProfileService.getCountryLocalStorage();
  }

  pageIsValid(page: string, submitResult: DataObject) {
    return this.transactionValidationService.isPageValid(page, submitResult, this.getUserCountry(), this.pageLink);
  }

  getPageName(pageName) {
    if (pageName) {
      return this.translateService.getTranslation(pageName.trim().toLowerCase());
    }
  }

  setQueryParams(pageSlug: string, queryParams: DataObject) {
    if (['createcustomer', 'updatecustomer' ].includes(pageSlug)) {
      return {
        ...queryParams,
        validation: true,
        hash: this.activatedRoute?.snapshot?.queryParams['hash'] || null
      };
    }
    return {
      ...queryParams,
      validation: true,
    };
  }

}
